import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid gap-1 whitespace-normal py-1" }
const _hoisted_2 = { class: "flex items-start gap-2.5" }
const _hoisted_3 = { class: "min-w-0 text-sm font-medium [overflow-wrap:anywhere]" }
const _hoisted_4 = {
  key: 0,
  class: "ml-1.5 whitespace-nowrap rounded-sm border border-gray-300 px-1.5 text-xs uppercase tracking-wide text-gray-500",
  "data-cy": "conflict-archived-tag"
}
const _hoisted_5 = {
  class: "ml-auto flex flex-none flex-wrap justify-end gap-1",
  "data-cy": "conflict-matched-fields"
}
const _hoisted_6 = {
  key: 0,
  class: "bg-yellow-200 px-0.5 text-yellow-900",
  "data-cy": "conflict-matched-word"
}
const _hoisted_7 = { class: "flex flex-wrap gap-3 text-xs font-normal text-gray-500" }
const _hoisted_8 = { "data-cy": "conflict-from-party" }
const _hoisted_9 = { class: "font-medium text-gray-700" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "font-medium text-amber-700"
}

import { computed } from 'vue';
import LlListItem from '@/components/LlListItem.vue';
import ConflictFieldPill from './ConflictFieldPill.vue';
import { highlightTokens, truncate } from '../utils/conflictHighlightHelpers';
import type { ConflictResultRow } from '../models/conflictTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConflictResultRow',
  props: {
    row: {},
    showFraction: { type: Boolean },
    grouped: { type: Boolean }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const valueLines = computed(() => {
  const byValue = new Map<string, string[]>();

  props.row.fields.forEach((field) => {
    const value = field.value ?? '';
    byValue.set(value, (byValue.get(value) ?? []).concat(field.matchedWords));
  });

  return Array.from(byValue, ([value, matchedWords]) => ({
    value,
    tokens: highlightTokens(truncate(value), matchedWords),
  }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LlListItem, {
    clickable: "",
    "data-cy": "conflict-result-row",
    class: _normalizeClass(["border-b border-gray-200 last:border-b-0", { 'border-l-[3px] border-l-gray-300': __props.grouped }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open', __props.row)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.row.recordLabel) + " ", 1),
            (__props.row.archived)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Archived "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.row.fields, (field) => {
              return (_openBlock(), _createBlock(ConflictFieldPill, {
                key: field.id,
                field: field.id
              }, null, 8, ["field"]))
            }), 128))
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueLines.value, (line) => {
          return (_openBlock(), _createElementBlock("span", {
            key: line.value,
            class: "text-xs text-gray-700 [overflow-wrap:anywhere]"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.tokens, (token, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (token.matched)
                  ? (_openBlock(), _createElementBlock("mark", _hoisted_6, _toDisplayString(token.text), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(token.text), 1)
                    ], 64))
              ], 64))
            }), 128))
          ]))
        }), 128)),
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _cache[1] || (_cache[1] = _createTextVNode(" From ", -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(__props.row.party), 1)
          ]),
          (__props.row.clientLabel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Client · " + _toDisplayString(__props.row.clientLabel), 1))
            : _createCommentVNode("", true),
          (__props.showFraction)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(__props.row.matchedWordCount) + " of " + _toDisplayString(__props.row.partyWordCount) + " words ", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})